function bestSeller_init() {  
  if ( jQuery( ".labelWrapper" ).length ) {	
      var best_pid = jQuery(".labelWrapper").data('pid'); 
      var best_handle = jQuery(".labelWrapper").data('phandle'); 
      var best_shop = jQuery(".labelWrapper").data('shop'); 	
  }
	console.log(best_shop);
    console.log(best_handle);
    console.log(best_pid);
  
	jQuery.ajax({
	url: 'http://labelnbadges.mstindia.com/get_data.php',
	data: { prodID: best_pid, shopnm: best_shop , best_handle:best_handle},
	dataType: 'jsonp',
	jsonpCallback: 'bestsellCallback',
	success: function(json) {        
		console.log(json.pname);
 		var pids =  json.pname;
      	var prdhandles = pids.split(',');	
		prdhandles = prdhandles.map(function (e) {
		  return e.trim();
		});				
		for(var i = 0; i < prdhandles.length; i++) {          
          var fetchPurl = prdhandles[i];	
          	jQuery.getJSON('https://'+ best_shop +'/products/'+ fetchPurl +'.js', function(product){
				var prod_price =  relEngMoney.formatMoney(product.price, Shopify.money_format);
				var prod_qunt; 
				var variant_id;
				var Vvalues = [];
				jQuery.each(product.variants,function(i,v){
				prod_qunt = v.inventory_quantity;
				variant_id = v.id;
				Vvalues.push(v.id);
				});	
				});	
            if(best_pid == prdhandles[i])
            {
              console.log("true");
              jQuery(".labelWrapper").append("<img id='theImg' src='//cdn.shopify.com/s/files/1/0069/1355/6539/t/9/assets/bestseller.jpg?10660797842292832107'/>");
            }          
        }
    	}
	});
}
if (window.addEventListener) { window.addEventListener("load", bestSeller_init, false); }
else { window.attachEvent("onload", bestSeller_init); }	
